import { useState } from 'react';
import '../styles/home.css';
// import '../styles/media.css';
import  Menu  from './Menu';
import About from './About';
import Experience from './Experience';
import Education from './Education';
import Findme from './Findme';


const ABOUT_TAB_ID = 1;
const EXP_TAB_ID = 2;
const EDU_TAB_ID = 3;
const FIND_TAB_ID = 4;



const tabIds = {
    'about': 1,
    'exp': 2,
    'edu': 3,
    'find': 4
};



const Home = (props) => {

    let tabName = props.match.params.tab;

    const [currentTabId, setCurrentTabId] = useState(tabIds[tabName] ? tabIds[tabName] : ABOUT_TAB_ID);


    function changeTab(e){
        let target = e.target.getAttribute("value"); 
        setCurrentTabId(tabIds[target]);
    }


    return(
        <div className='container-fluid'>
            <div className='row app-content'>
                <div className='col-sm-3' id="left-panel" key={"left-panel"}>
                    <Menu menuHandler={changeTab} />
                </div>
                <div item className='col-sm-9' id="right-content" key={"right-content"}>
                    <div className='row'>
                        <div className='col-sm-12 full-name'>
                            <small>Pooya</small>
                            <span>Oladazimi</span>
                        </div>                    
                    </div> 
                    <br></br>
                    <br></br>
                    <div className='row' id="content-holder">
                        <div className='col-sm-12'>
                        {currentTabId === ABOUT_TAB_ID && <About></About>}
                        {currentTabId === EXP_TAB_ID && <Experience></Experience>}
                        {currentTabId === EDU_TAB_ID && <Education></Education>}
                        {currentTabId === FIND_TAB_ID && <Findme></Findme>}
                        </div>
                    </div> 
                </div>
            </div> 
            <div className='row' id="footer">
                <div className='col-sm-12' key={"footer"}>
                    <small>Designed & Developed by <i>Pooya Oladazmi</i></small>
                </div>                    
            </div>                               
        </div>
    );
}


export default Home;